import React from 'react';

export const AdvertBar = () => (
  <div
    className="absolute text-xs text-center text-white font-bold p-1 bottom-0 w-full text-shadow uppercase"
    style={{ backgroundColor: 'rgba(160,174,192, 0.75)' }}
  >
    Advertisement
  </div>
);